import logoLead from '@/assets/logo/lighthouse1_free.png';
import logoLeadText from '@/assets/logo/lighthouse1_free_text.png';
import panelLogo from '@/assets/logo/lead-logo.png';

import type { Brand } from './types';

export const lead: Brand = {
  key: 'lead',
  appType: 'LEAD',
  name: 'LEAD',
  shortName: 'LEAD',
  emblem: 'LEAD',
  productName: 'JobIQ',
  productBadge: 'JQ',
  legalName: 'JobIQ AG, Zürich',
  byline: 'JobIQ AG',
  logos: { main: logoLead, text: logoLeadText, panel: panelLogo, panelInvert: false },
  wordmark: null,
  panelHeadlineKey: 'auth.panel.headline',
  theme: {},
  legalLinks: {
    imprint: { de: 'https://jobiq.ch/de-ch/impressum', en: 'https://jobiq.ch/en-ch/impressum' },
    privacy: { de: 'https://jobiq.ch/de-ch/privacy', en: 'https://jobiq.ch/en-ch/privacy' },
    terms: { de: 'https://jobiq.ch/de-ch/terms', en: 'https://jobiq.ch/en-ch/terms' },
  },
};
